<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">满减活动详情</p>
		</sub-ibox-title>
		<section class="content">
			<ul class="promotion-ditail">
				<li class="fx"><p>活动名称</p><div>{{info.name}}</div></li>
				<li class="fx"><p>创建时间</p><div>{{info.c_time}}</div></li>
				<li class="fx"><p>开始时间</p><div>{{info.start_time}}</div></li>
				<li class="fx"><p>结束时间</p><div>{{info.end_time}}</div></li>
				<li class="fx">
					<p>门槛条件</p>
					<ol>
						<li><div v-for="item in info.condition">满{{item.least_cost | filterMoney}}元 减 {{item.reduce_cost | filterMoney}}元</div></li>
					</ol>
				</li>
				<li class="fx">
					<p>适用门店</p>
					<div>
						<ol>
							<li v-for="items in info.shop_list || []">{{items.name}}</li>
						</ol>
					</div>
				</li>
			</ul>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content {
		border-top: none;
	}
	.promotion-ditail{
		>li{
			padding: px-em(10px) 0;
		}
		p{
			width: px-em(160px);
		}
	}
</style>
<script>
	import { mapState, mapActions } from 'vuex';
	export default {
		name: 'PromotionsInfo',
		components: {},
		data() {
			return {
				entityId: '',
				priceCondition: {
					achive: 0,
					price: 0
				},
				entityNameList: []
			}
		},
		
		computed: {
			...mapState({
				info: state => state.promotions.detail,
				shopList: state => state.shopManage.shopList.list,
			})
		},
		
		async mounted() {
			this.entityId = this.$route.query.id || null;
			if(!this.$re_Number(this.entityId)) return;
			await this.getShopList({count: 10000, offset: 0});
			await this.handleActiveDetail();
		},
		/*
		 * 事件处理
		 */
		methods: {
			//获取活动详情
			async handleActiveDetail() {
				await this.getPromotionDetail({entityId: this.entityId});
			},
			...mapActions(['getPromotionDetail', 'getShopList']),
		},
	}
</script>


// WEBPACK FOOTER //
// PromotionInfoPage.vue?28f5d51d